const currency = {
  DE: { ISO: 'EUR', SYM: '€' },
  FR: { ISO: 'EUR', SYM: '€' },
  AT: { ISO: 'EUR', SYM: '€' },
  BE: { ISO: 'EUR', SYM: '€' },
  CY: { ISO: 'EUR', SYM: '€' },
  EE: { ISO: 'EUR', SYM: '€' },
  FI: { ISO: 'EUR', SYM: '€' },
  GR: { ISO: 'EUR', SYM: '€' },
  IE: { ISO: 'EUR', SYM: '€' },
  IT: { ISO: 'EUR', SYM: '€' },
  LV: { ISO: 'EUR', SYM: '€' },
  LT: { ISO: 'EUR', SYM: '€' },
  LU: { ISO: 'EUR', SYM: '€' },
  MT: { ISO: 'EUR', SYM: '€' },
  NL: { ISO: 'EUR', SYM: '€' },
  PT: { ISO: 'EUR', SYM: '€' },
  SK: { ISO: 'EUR', SYM: '€' },
  SI: { ISO: 'EUR', SYM: '€' },
  ES: { ISO: 'EUR', SYM: '€' },
  EZ: { ISO: 'EUR', SYM: '€' },
  GB: { ISO: 'GBP', SYM: '£' },
  US: { ISO: 'USD', SYM: '$' },
};
const defaultCur = { ISO: 'USD', SYM: '$' };

export function getCurrency(country: string) {
  let cur = defaultCur;
  if (currency[country]) cur = currency[country];
  return cur;
}
export function getSymbolFromCurrency(cur: string) {
  let ex = Object.values(currency).find((x) => x.ISO === cur);
  ex = ex || defaultCur;
  return ex.SYM;
}
